<template>
  <form @submit.prevent="submitForm">
    <div>
      <p class="mb-4">Are you sure you wish to delete this comment?</p>
      <button class="btn btn-brand" :disabled="pending">Delete</button>

      <slot :disabled="pending" />
    </div>
  </form>
</template>

<script>
export default {
  props: {
    submitAction: {
      type: Function,
      default: () => Promise.reject(Error('submitAction in not defined')),
    },
    comment: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      pending: false,
    };
  },

  methods: {
    async submitForm() {
      this.pending = true;

      try {
        await this.submitAction(this.comment.uuid);
      } catch (error) {
        //
      }
      this.pending = false;
    },
  },
};
</script>
